module.exports = __webpack_public_path__ + "static/media/grow-your-team.e5015f7a.svg";